import SectionSkeletons from "./SectionSkeletons";

const PageRouteFallback = () => (
  <div className="flex w-full flex-col items-center gap-14 pb-20 md:gap-20" aria-busy="true" aria-label="Loading page">
    <section className="layout-shell flex w-full flex-col items-center gap-4 px-4 pt-28 md:pt-36" aria-hidden="true">
      <div className="h-6 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-slate-700/80" />
      <div className="h-10 w-2/3 max-w-2xl animate-pulse rounded-xl bg-slate-200 dark:bg-slate-700/80" />
      <div className="h-4 w-full max-w-xl animate-pulse rounded-xl bg-slate-200 dark:bg-slate-700/80" />
      <div className="aspect-video w-full max-w-2xl animate-pulse rounded-3xl bg-slate-200 dark:bg-slate-700/80" />
    </section>
    <div className="flex w-11/12 flex-col items-center gap-14 md:gap-20">
      <SectionSkeletons variant="features" />
      <SectionSkeletons variant="features" />
    </div>
  </div>
);

export default PageRouteFallback;
